export default ($) => {
  $('select.custom').each(function() {
    let $this = $(this),
      numberOfOptions = $(this).children('option').length;
    let miniSelect = $this.hasClass('mini-select');
    let selectStyledClass = 'select-styled';

    if (miniSelect) {
      selectStyledClass = selectStyledClass + ' mini-styled btn arrow';
    }

    $this.wrap('<div class="select" tabindex="0"></div>');
    $this.closest('.select').addClass('custom');
    $this.addClass('select-hidden');

    $this.after('<div class="' + selectStyledClass + '"></div>');
    let $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());

    if (miniSelect) {
      $styledSelect.text($this.data('title'));
      $(this).val('').change();
    }

    let $list = $('<ul />', {
      'class': 'select-options js-' + $(this).attr('name')
    }).insertAfter($styledSelect);
    if (miniSelect) {
      $('<li />', {
        text: $this.data('title'),
        rel: '',
      }).appendTo($list);
    }
    for (let i = 0; i < numberOfOptions; i++) {
      let currentOption = $this.children('option').eq(i);
      $('<li />', {
        class: currentOption.prop('disabled') ? 'disabled' : '',
        text: currentOption.text(),
        rel: currentOption.val(),
      }).appendTo($list);
    }

    let $listItems = $list.children('li');
    $list.hide();

    $styledSelect.click(function(e) {
      e.stopPropagation();
      $('.select-styled.active').not(this).removeClass('active').next('ul.select-options').hide();
      $(this).toggleClass('active').next('ul.select-options').toggle();
    });

    $this.val() ? $styledSelect.addClass('hasValue') : $styledSelect.removeClass('hasValue');

    $listItems.click(function(e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass('active');
      $list.hide();
      $this.val($(this).attr('rel')).change();

      $this.val() ? $styledSelect.addClass('hasValue') : $styledSelect.removeClass('hasValue');
    });

    $(document).click(function(event) {
      if (!$(event.target).closest($this).length) {
        $styledSelect.removeClass('active');
        $list.hide();
      }
    });

    $this.on('change', function () {
      const selectedValue = $this.val();
      const selectedText = $this.find(`option[value="${selectedValue}"]`).text();

      $styledSelect.text(selectedText);

      $listItems.removeClass('selected');
      $listItems
        .filter(`[rel="${selectedValue}"]`)
        .addClass('selected');

      selectedValue ? $styledSelect.addClass('hasValue') : $styledSelect.removeClass('hasValue');
    });

    $this.removeClass('custom');
  });
}

(() => {
  let lookingForForm = $('.js-lfForm');

  let activateInterest = (selectJQElement, button) => {
    selectJQElement.on('change', function () {
      let $selected  = $(this).find('option:selected');
      let currentVal = $selected.val();
      let target     = $selected.data('target');
      let label      = $.trim($selected.text());
      let isReal     = !!currentVal && label !== 'Looking for...';

      button.attr('href', currentVal);
      button.attr('target', target);
      button.attr('disabled', !isReal);
      button.attr('aria-disabled', isReal ? 'false' : 'true');
      button.attr('aria-label', isReal ? 'Go to ' + label : 'Go');
    });
  };

  lookingForForm.each(function () {
    let _form = $(this);
    let categorySelect = _form.find('.js-lfFormCategory');
    let linksSelect    = _form.find('.js-lfFormLinks');
    let button         = _form.find('.js-learnMoreBtn');
    linksSelect.next('div').addClass('-disabled');

    categorySelect.on('change', function () {
      let currentLinks = $(this).find('option:selected').data('links');
      let styledSelect = linksSelect.next('.select-styled');
      let listBox      = linksSelect.siblings('.select-options');
      linksSelect.next('div').removeClass('-disabled');
      button.attr('disabled', true);
      button.attr('aria-disabled', 'true');

      linksSelect.empty();
      listBox.empty();
      styledSelect.removeClass('hasValue');

      Array.prototype.forEach.call(currentLinks, function (item, index) {
        let text = item['title'] ? item['title'] : item['name'];
        let target = item['target'] ? item['target'] : '';

        if (index === 0) {
          styledSelect.text(text);
          button.attr('href', item['url']);
          button.attr('aria-label', 'Go');
        }

        $('<option />', {
          value: item['url'],
          text: text,
          'data-target': target,
        }).appendTo(linksSelect);

        $('<li />', {
          text: text,
          rel: item['url'],
          class: text === 'Looking for...' ? 'disabled' : ''
        }).appendTo(listBox);
      });

      let $listItems = listBox.children('li');

      $listItems.click(function(e) {
        e.stopPropagation();
        styledSelect.text($(this).text()).removeClass('active');
        listBox.hide();
        linksSelect.val($(this).attr('rel')).change();

        linksSelect.val() ? styledSelect.addClass('hasValue') : styledSelect.removeClass('hasValue');
      });

      activateInterest(linksSelect, button);
    });

    activateInterest(linksSelect, button);
  });
})();